import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import {
  AbandonedCheckoutPage,
  abandonedCheckoutQueryOptions,
} from '@/features/abandoned-checkouts';

export const Route = createFileRoute('/_authed/_active/s/$storeId/abandoned-checkouts/$checkoutId')(
  {
    staticData: { tours: ['abandoned.detail'] },
    beforeLoad: ({ context }) => {
      requirePermission(context.me, 'orders.read');
    },
    loader: async ({ context, params }) => {
      const checkout = await context.queryClient.query({
        ...abandonedCheckoutQueryOptions(params.storeId, params.checkoutId),
        staleTime: 'static',
      });
      return { crumb: checkout.email };
    },
    component: AbandonedCheckoutPage,
  },
);
